import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appToolbarHost]'
})
export class ToolbarHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
